import { BehaviorSubject } from 'rxjs';
import Cookies from "js-cookie";
import { handleResponse } from '../app/handleResponse';
import { getCSRFToken } from '../app/getCSRFToken';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

const login = (emailAddress, password) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-XSRF-TOKEN": getCSRFToken(),
        },
        body: JSON.stringify({ emailAddress, password })
    };

    return fetch(`/api/login/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user.emailAddress) {
                Cookies.set("EmailAddress", user.emailAddress, { expires: 365, secure: true, sameSite: "strict" });
                delete user.emailAddress;

                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem("currentUser", JSON.stringify(user));
                currentUserSubject.next(user);
            }

            return user;
        });
}

const validateTwoFactorAuthenticationCode = (loginKey, twoFactorAuthenticationCode) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-XSRF-TOKEN": getCSRFToken(),
        },
        body: JSON.stringify({ loginKey, twoFactorAuthenticationCode })
    };

    return fetch(`/api/login/authenticatetwofactorauthenticationcode`, requestOptions)
        .then(handleResponse)
        .then(user => {
            Cookies.set("EmailAddress", user.emailAddress, { expires: 365, secure: true, sameSite: "strict" });
            delete user.emailAddress;

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("currentUser", JSON.stringify(user));            
            currentUserSubject.next(user);

            return user;
        });
}

const loginWithToken = (token) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-XSRF-TOKEN": getCSRFToken(),
        },
        body: JSON.stringify({ token })
    };

    return fetch(`/api/login/authenticatetoken`, requestOptions)
        .then(handleResponse)
        .then(user => {
            Cookies.set("EmailAddress", user.emailAddress, { expires: 365, secure: true, sameSite: "strict" });
            delete user.emailAddress;

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("currentUser", JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

const loginWithKey = (emailAddress, key) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-XSRF-TOKEN": getCSRFToken(),
        },
        body: JSON.stringify({ emailAddress, key })
    };

    return fetch(`/api/login/authenticatekey`, requestOptions)
        .then(handleResponse)
        .then(user => {
            Cookies.set("EmailAddress", user.emailAddress, { expires: 365, secure: true, sameSite: "strict" });
            delete user.emailAddress;

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem("currentUser", JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

const logout = () => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-XSRF-TOKEN": getCSRFToken(),
        },
        body: JSON.stringify({})
    };

    return fetch(`/api/logout`, requestOptions)
        .then(handleResponse)
        .then(result => {
            // remove user from local storage to log user out
            localStorage.removeItem("currentUser");
            currentUserSubject.next(null);

            return result;
        });
}

export const authenticationService = {
    login,
    loginWithToken,
    loginWithKey,
    validateTwoFactorAuthenticationCode,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value }
};